import { render, staticRenderFns } from "./Translation.vue?vue&type=template&id=19a6cdc2&scoped=true&"
import script from "./Translation.vue?vue&type=script&lang=js&"
export * from "./Translation.vue?vue&type=script&lang=js&"
import style0 from "./Translation.vue?vue&type=style&index=0&id=19a6cdc2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a6cdc2",
  null
  
)

export default component.exports